import { UnmountClosed } from 'react-collapse';
import moment from 'moment';
import React from 'react';
import { Table } from 'semantic-ui-react';
import styled from 'styled-components';
import {
  ResultInfoBlock,
  ResultContent,
  H1,
  ResultHeaderBlock,
  ResultHeaderName,
  HeaderName,
  TitleOfCbju,
} from '../userPageStyles';
import ArrowBackIcon from '../../../../images/arrow-black.png';
import {
  defaultEatingTitle,
  defualt_portion,
  defaultEating,
  breakfastTags,
} from '../../youslim2.0_Constants';

const ResultBlock = React.memo(({ usersGeneratedData, dishTags }) => {
  const [isOpened, setIsOpened] = React.useState([false]);
  const [isOpenedDays, setIsOpenedDays] = React.useState([[false]]);
  const [isChildCollapseAnimated, setIsChildCollapseAnimated] = React.useState(false);
  const [cbjuArr, setCbjuArr] = React.useState(false);
  const [rebuildResult, setRebuildResult] = React.useState([[]]);

  const rebuilbInfoSearch = React.useCallback(
    (result, newRebuildResultArr) => {
      const newRebuildResult = [];
      const newDishTags = [];
      defaultEating.forEach((eating, index) => {
        if (
          result &&
          result.rebuild &&
          result.rebuild.empty_positions &&
          result.rebuild.empty_positions[eating]
        )
          newRebuildResult.push(
            `${defaultEatingTitle[index].text}, ${
              result.rebuild.empty_positions[eating].length
                ? `теги: ${result.rebuild.empty_positions[eating].map((dish) => {
                    breakfastTags.forEach((dishTag) => {
                      if (dish.id === dishTag.id) {
                        newDishTags.push(`${dishTag.name} `);
                      }
                    });
                    return newDishTags;
                  })} `
                : ''
            }`,
          );
      });
      newRebuildResultArr.push(newRebuildResult);
    },
    [usersGeneratedData],
  );

  React.useEffect(() => {
    const newIsOpened = [];
    const newIsOpenedDays = [];
    const newCbjuArr = [];
    const newRebuildResultArr = [];

    usersGeneratedData.forEach((result, index) => {
      rebuilbInfoSearch(result, newRebuildResultArr);
      newIsOpened.push(false);
      newIsOpenedDays.push([]);
      newCbjuArr.push([]);

      result.menus.forEach((menuForDay, dayIndex) => {
        newIsOpenedDays[index].push(false);
        newCbjuArr[index].push([]);
        defaultEating.forEach((eating, eatingIndex) => {
          let calories = 0;
          let protein = 0;
          let fats = 0;
          let carbohydrates = 0;
          if (!menuForDay.menu[eating]) {
            newCbjuArr[index][dayIndex].push([]);
            return;
          }
          menuForDay.menu[eating].forEach((currentProduct) => {
            calories += +currentProduct.calories;
            protein += +currentProduct.animal_protein + +currentProduct.vegetable_protein;
            fats += +currentProduct.saturated_fat + +currentProduct.unsaturated_fats;
            carbohydrates +=
              +currentProduct.simple_carbohydrates + +currentProduct.complex_carbohydrates;
          });
          newCbjuArr[index][dayIndex].push({
            calories,
            protein,
            fats,
            carbohydrates,
          });
        });
      });
    });
    if (usersGeneratedData.length) {
      setCbjuArr([...newCbjuArr]);
      setIsOpenedDays([...newIsOpenedDays]);
      setIsOpened([...newIsOpened]);
      setRebuildResult([...newRebuildResultArr]);
    }
  }, [usersGeneratedData]);

  const onClickIsOpened = (i) => {
    const newIsOpened = isOpened;
    newIsOpened.splice(i, 1, !isOpened[i]);
    setIsOpened([...newIsOpened]);
  };

  const onClickIsOpenedDays = (i, daysIndex) => {
    const newIsOpened = isOpenedDays;
    newIsOpened[i].splice(daysIndex, 1, !newIsOpened[i][daysIndex]);
    setIsOpenedDays([...newIsOpened]);
    setIsChildCollapseAnimated(true);
  };

  return (
    <React.Fragment>
      <H1>Результаты</H1>
      {usersGeneratedData &&
        usersGeneratedData.map((result, i) => (
          <ResultContent>
            <ResultInfoBlock onClick={() => onClickIsOpened(i)}>
              <ImgArrow src={ArrowBackIcon} alt="arrow" isOpened={isOpened[i]} />
              <ResultHeaderBlock>
                <ResultHeaderName>{`id: ${result._id}`}</ResultHeaderName>
                <ResultHeaderName>
                  {result.count_restart >= 0 && `Перезапусков скрипта фф: ${result.count_restart}`}
                </ResultHeaderName>
                <ResultHeaderName>
                  {result.repeat > 1 && `Повторы: ${result.repeat}`}
                </ResultHeaderName>
                <ResultHeaderName>
                  {result.time_execute >= 0 &&
                    `Oбщее время генерации: ${result.time_execute.toFixed(2)}сек`}
                </ResultHeaderName>
                <ResultHeaderName className="result_rebuild_block">
                  {result.rebuild && result.rebuild.count > 0 ? (
                    <div
                      className="rebuild_tags"
                      data-title={rebuildResult.length >= i && rebuildResult[i]}
                    >
                      Пересборок данных: {result.rebuild.count}
                    </div>
                  ) : (
                    `Пересборок данных: 0`
                  )}
                </ResultHeaderName>

                <ResultHeaderName>
                  {moment(result.created_at).format('YYYY-MM-DD')}
                </ResultHeaderName>
              </ResultHeaderBlock>
            </ResultInfoBlock>
            <UnmountClosed
              isOpened={isOpened[i]}
              className={isChildCollapseAnimated ? 'parent_collapse' : ''}
              onRest={() => setIsChildCollapseAnimated(false)}
            >
              {result &&
                usersGeneratedData.length === isOpenedDays.length &&
                result.menus.map((menuForDay, daysIndex) => (
                  <React.Fragment>
                    <ResultInfoBlock onClick={() => onClickIsOpenedDays(i, daysIndex)}>
                      <ImgArrow
                        src={ArrowBackIcon}
                        alt="arrow"
                        isOpened={isOpenedDays[i][daysIndex]}
                      />
                      <ResultHeaderBlock>
                        <ResultHeaderName>{`Время генерации: ${menuForDay.time_execute.toFixed(
                          4,
                        )}`}</ResultHeaderName>
                        <ResultHeaderName>{`ФФ: ${menuForDay.best_fitness.toFixed(
                          4,
                        )}`}</ResultHeaderName>
                      </ResultHeaderBlock>
                    </ResultInfoBlock>
                    <UnmountClosed isOpened={isOpenedDays[i][daysIndex]}>
                      <Table celled>
                        <Table.Header>
                          <Table.Row>
                            {defaultEatingTitle.map((eating) => (
                              <Table.HeaderCell style={{ width: '15%' }}>
                                {eating.text}
                                <TitleOfCbju>
                                  {cbjuArr &&
                                    cbjuArr[i] &&
                                    cbjuArr[i][daysIndex] &&
                                    cbjuArr[i][daysIndex][eating.value] &&
                                    cbjuArr[i][daysIndex][eating.value].calories &&
                                    cbjuArr[i][daysIndex][eating.value].protein &&
                                    cbjuArr[i][daysIndex][eating.value].fats &&
                                    cbjuArr[i][daysIndex][eating.value].carbohydrates &&
                                    `K: ${cbjuArr[i][daysIndex][eating.value].calories.toFixed(
                                      1,
                                    )} | Б: ${cbjuArr[i][daysIndex][eating.value].protein.toFixed(
                                      1,
                                    )} | Ж: ${cbjuArr[i][daysIndex][eating.value].fats.toFixed(
                                      1,
                                    )} | У: ${cbjuArr[i][daysIndex][
                                      eating.value
                                    ].carbohydrates.toFixed(1)} `}
                                </TitleOfCbju>
                              </Table.HeaderCell>
                            ))}
                          </Table.Row>
                        </Table.Header>
                        <Table.Body>
                          <Table.Row>
                            <Table.Cell>
                              {result &&
                                menuForDay &&
                                menuForDay.menu &&
                                menuForDay.menu.breakfast &&
                                menuForDay.menu.breakfast.map((eating, i) => {
                                  return (
                                    <div>{`${eating.dish.title} (${
                                      eating.portion_id &&
                                      defualt_portion[eating.portion_id - 1].ru_value
                                    })`}</div>
                                  );
                                })}
                            </Table.Cell>
                            <Table.Cell>
                              {result &&
                                menuForDay &&
                                menuForDay.menu &&
                                menuForDay.menu.morningSnack &&
                                menuForDay.menu.morningSnack.map((eating, i) => {
                                  return (
                                    <div>{`${eating.dish.title} (${
                                      eating.portion_id &&
                                      defualt_portion[eating.portion_id - 1].ru_value
                                    })`}</div>
                                  );
                                })}
                            </Table.Cell>
                            <Table.Cell>
                              {result &&
                                menuForDay &&
                                menuForDay.menu &&
                                menuForDay.menu.lunch &&
                                menuForDay.menu.lunch.map((eating, i) => {
                                  return (
                                    <div>{`${eating.dish.title} (${
                                      eating.portion_id &&
                                      defualt_portion[eating.portion_id - 1].ru_value
                                    })`}</div>
                                  );
                                })}
                            </Table.Cell>
                            <Table.Cell>
                              {result &&
                                menuForDay &&
                                menuForDay.menu &&
                                menuForDay.menu.afternoonSnack &&
                                menuForDay.menu.afternoonSnack.map((eating, i) => {
                                  return (
                                    <div>{`${eating.dish.title} (${
                                      eating.portion_id &&
                                      defualt_portion[eating.portion_id - 1].ru_value
                                    })`}</div>
                                  );
                                })}
                            </Table.Cell>
                            <Table.Cell>
                              {result &&
                                menuForDay &&
                                menuForDay.menu &&
                                menuForDay.menu.dinner &&
                                menuForDay.menu.dinner.map((eating, i) => {
                                  return (
                                    <div>{`${eating.dish.title} (${
                                      eating.portion_id &&
                                      defualt_portion[eating.portion_id - 1].ru_value
                                    })`}</div>
                                  );
                                })}
                            </Table.Cell>
                            <Table.Cell>
                              {result &&
                                menuForDay &&
                                menuForDay.menu &&
                                menuForDay.menu.eveningSnack &&
                                menuForDay.menu.eveningSnack.map((eating, i) => {
                                  return (
                                    <div>{`${eating.dish.title} (${
                                      eating.portion_id &&
                                      defualt_portion[eating.portion_id - 1].ru_value
                                    })`}</div>
                                  );
                                })}
                            </Table.Cell>
                          </Table.Row>
                        </Table.Body>
                      </Table>
                      <Table celled>
                        <Table.Header>
                          <Table.Row>
                            <Table.HeaderCell />
                            <Table.HeaderCell>
                              <HeaderName>Σ К</HeaderName>
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                              <HeaderName>Σ Б</HeaderName>
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                              <HeaderName>Σ ЖБ</HeaderName>
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                              <HeaderName>Σ РБ</HeaderName>
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                              <HeaderName>Σ Ж</HeaderName>
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                              <HeaderName>Σ НЖ</HeaderName>
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                              <HeaderName>Σ ННЖ</HeaderName>
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                              <HeaderName> Σ У</HeaderName>
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                              <HeaderName>Σ ПУ</HeaderName>
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                              <HeaderName>Σ СУ</HeaderName>
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                              <HeaderName>Σ кл в г</HeaderName>
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                              <HeaderName>Σ кал утро</HeaderName>
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                              <HeaderName>Σ кал осн</HeaderName>
                            </Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>
                        <Table.Body>
                          <Table.Row>
                            <Table.Cell>Цель</Table.Cell>
                            <Table.Cell>
                              {menuForDay.result_nutrients_generate && result.target_value.calories}
                            </Table.Cell>
                            <Table.Cell>
                              {result.target_value && result.target_value.proteins}
                            </Table.Cell>
                            <Table.Cell>
                              {result.target_value && result.target_value.animal_protein}
                            </Table.Cell>
                            <Table.Cell>
                              {result.target_value && result.target_value.vegetable_protein}
                            </Table.Cell>
                            <Table.Cell>
                              {result.target_value && result.target_value.fats}
                            </Table.Cell>
                            <Table.Cell>
                              {result.target_value && result.target_value.saturated_fat}
                            </Table.Cell>
                            <Table.Cell>
                              {result.target_value && result.target_value.unsaturated_fats}
                            </Table.Cell>
                            <Table.Cell>
                              {result.target_value && result.target_value.carbohydrates}
                            </Table.Cell>
                            <Table.Cell>
                              {result.target_value && result.target_value.simple_carbohydrates}
                            </Table.Cell>
                            <Table.Cell>
                              {result.target_value && result.target_value.complex_carbohydrates}
                            </Table.Cell>
                            <Table.Cell>
                              {result.target_value && result.target_value.cellulose}
                            </Table.Cell>

                            <Table.Cell rowSpan="2">-</Table.Cell>
                            <Table.Cell rowSpan="2">-</Table.Cell>
                          </Table.Row>
                          <Table.Row>
                            <Table.Cell>Актуальные</Table.Cell>
                            <Table.Cell>
                              {menuForDay.result_nutrients_generate &&
                                menuForDay.result_nutrients_generate.calories}
                            </Table.Cell>
                            <Table.Cell>
                              {menuForDay.result_nutrients_generate &&
                                menuForDay.result_nutrients_generate.proteins}
                            </Table.Cell>
                            <Table.Cell>
                              {menuForDay.result_nutrients_generate &&
                                menuForDay.result_nutrients_generate.animal_protein}
                            </Table.Cell>
                            <Table.Cell>
                              {menuForDay.result_nutrients_generate &&
                                menuForDay.result_nutrients_generate.vegetable_protein}
                            </Table.Cell>
                            <Table.Cell>
                              {menuForDay.result_nutrients_generate &&
                                menuForDay.result_nutrients_generate.fats}
                            </Table.Cell>
                            <Table.Cell>
                              {menuForDay.result_nutrients_generate &&
                                menuForDay.result_nutrients_generate.saturated_fat}
                            </Table.Cell>
                            <Table.Cell>
                              {menuForDay.result_nutrients_generate &&
                                menuForDay.result_nutrients_generate.unsaturated_fats}
                            </Table.Cell>
                            <Table.Cell>
                              {menuForDay.result_nutrients_generate &&
                                menuForDay.result_nutrients_generate.carbohydrates}
                            </Table.Cell>
                            <Table.Cell>
                              {menuForDay.result_nutrients_generate &&
                                menuForDay.result_nutrients_generate.simple_carbohydrates}
                            </Table.Cell>
                            <Table.Cell>
                              {menuForDay.result_nutrients_generate &&
                                menuForDay.result_nutrients_generate.complex_carbohydrates}
                            </Table.Cell>
                            <Table.Cell>
                              {menuForDay.result_nutrients_generate &&
                                menuForDay.result_nutrients_generate.cellulose}
                            </Table.Cell>
                          </Table.Row>
                        </Table.Body>

                        <Table.Body>
                          <Table.Row>
                            <Table.Cell>Цель в гр</Table.Cell>
                            <Table.Cell>-</Table.Cell>
                            <Table.Cell>
                              {result.target_value && (result.target_value.proteins / 4).toFixed(2)}
                            </Table.Cell>
                            <Table.Cell>
                              {result.target_value &&
                                (result.target_value.animal_protein / 4).toFixed(2)}
                            </Table.Cell>
                            <Table.Cell>
                              {result.target_value &&
                                (result.target_value.vegetable_protein / 4).toFixed(2)}
                            </Table.Cell>
                            <Table.Cell>
                              {result.target_value && (result.target_value.fats / 9).toFixed(2)}
                            </Table.Cell>
                            <Table.Cell>
                              {result.target_value &&
                                (result.target_value.saturated_fat / 9).toFixed(2)}
                            </Table.Cell>
                            <Table.Cell>
                              {result.target_value &&
                                (result.target_value.unsaturated_fats / 9).toFixed(2)}
                            </Table.Cell>
                            <Table.Cell>
                              {result.target_value &&
                                (result.target_value.carbohydrates / 4).toFixed(2)}
                            </Table.Cell>
                            <Table.Cell>
                              {result.target_value &&
                                (result.target_value.simple_carbohydrates / 4).toFixed(2)}
                            </Table.Cell>
                            <Table.Cell>
                              {result.target_value &&
                                (result.target_value.complex_carbohydrates / 4).toFixed(2)}
                            </Table.Cell>
                            <Table.Cell>
                              {result.target_value && result.target_value.cellulose}
                            </Table.Cell>
                            <Table.Cell rowSpan="2">-</Table.Cell>
                            <Table.Cell rowSpan="2">-</Table.Cell>
                          </Table.Row>
                          <Table.Row>
                            <Table.Cell>Актуальные в гр</Table.Cell>
                            <Table.Cell>-</Table.Cell>
                            <Table.Cell>
                              {menuForDay.result_nutrients_generate &&
                                (menuForDay.result_nutrients_generate.proteins / 4).toFixed(2)}
                            </Table.Cell>
                            <Table.Cell>
                              {menuForDay.result_nutrients_generate &&
                                (menuForDay.result_nutrients_generate.animal_protein / 4).toFixed(
                                  2,
                                )}
                            </Table.Cell>
                            <Table.Cell>
                              {menuForDay.result_nutrients_generate &&
                                (
                                  menuForDay.result_nutrients_generate.vegetable_protein / 4
                                ).toFixed(2)}
                            </Table.Cell>
                            <Table.Cell>
                              {menuForDay.result_nutrients_generate &&
                                (menuForDay.result_nutrients_generate.fats / 9).toFixed(2)}
                            </Table.Cell>
                            <Table.Cell>
                              {menuForDay.result_nutrients_generate &&
                                (menuForDay.result_nutrients_generate.saturated_fat / 9).toFixed(2)}
                            </Table.Cell>
                            <Table.Cell>
                              {menuForDay.result_nutrients_generate &&
                                (menuForDay.result_nutrients_generate.unsaturated_fats / 9).toFixed(
                                  2,
                                )}
                            </Table.Cell>
                            <Table.Cell>
                              {menuForDay.result_nutrients_generate &&
                                (menuForDay.result_nutrients_generate.carbohydrates / 4).toFixed(2)}
                            </Table.Cell>
                            <Table.Cell>
                              {menuForDay.result_nutrients_generate &&
                                (
                                  menuForDay.result_nutrients_generate.simple_carbohydrates / 4
                                ).toFixed(2)}
                            </Table.Cell>
                            <Table.Cell>
                              {menuForDay.result_nutrients_generate &&
                                (
                                  menuForDay.result_nutrients_generate.complex_carbohydrates / 4
                                ).toFixed(2)}
                            </Table.Cell>
                            <Table.Cell>
                              {menuForDay.result_nutrients_generate &&
                                menuForDay.result_nutrients_generate.cellulose}
                            </Table.Cell>
                          </Table.Row>
                        </Table.Body>
                      </Table>
                    </UnmountClosed>
                  </React.Fragment>
                ))}
            </UnmountClosed>
          </ResultContent>
        ))}
    </React.Fragment>
  );
});

export default ResultBlock;

const ImgArrow = styled.img`
  position: absolute;
  left: 15px;
  bottom: 10px;
  width: 30px;
  height: 30px;
  transition: 0.3s;
  transform: ${(props) => (props.isOpened ? 'rotate(270deg)' : 'rotate(90deg)')};
`;



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/TestPage/ResultBlock/index.js